import { getStandardSyncerFields } from '../syncUp';
import { AIRCRAFT_COUNTABLE_FLIGHT_TIME, AIRCRAFT_COUNTABLE_TACH_TIME } from './countables';
let counter = 0;
export const countableChangeItemFields = `
    id
    deleted
    editableByUserIds
    aircraftId
    flightId
    legId
    createdAt
    createdByName
    place
    type
    changeTypes
    changeValues
    countableTypes
    countableValuesBefore
    countableValuesAfter
    _version
`.trim();
export const countableChangeSyncerDefinition = (countableChange) => {
    const c = ++counter;
    const [commandName, inputType] = countableChange._version
        ? ['updateCountableChange', 'UpdateCountableChangeInput']
        : ['createCountableChange', 'CreateCountableChangeInput'];
    const input = countableChangeToDb(countableChange);
    const { mutationName, inputKey, query } = getStandardSyncerFields(commandName, c, countableChangeItemFields);
    return {
        query,
        input,
        inputKey,
        inputType,
        mutationName,
        remoteToLocalTransform: countableChangeFromDb,
        getNeedsResync,
        queryName: 'getCountableChange',
    };
};
export const countableChangeToDb = (countableChange) => {
    return {
        id: countableChange.id,
        deleted: countableChange.deleted,
        aircraftId: countableChange.aircraftId,
        flightId: countableChange.flightId,
        legId: countableChange.legId,
        createdAt: countableChange.createdAt.toISOString(),
        createdByName: countableChange.createdByName,
        place: countableChange.place,
        type: countableChange.type,
        changeTypes: countableChange.changeTypes.length ? countableChange.changeTypes : null,
        changeValues: countableChange.changeValues.length ? countableChange.changeValues : null,
        countableTypes: countableChange.countableTypes,
        countableValuesBefore: countableChange.countableValuesBefore,
        countableValuesAfter: countableChange.countableValuesAfter,
        _version: countableChange._version,
    };
};
const migrateTypes = (inputTypes, aircraftId) => {
    if (aircraftId !== '98a19ab5-292c-4d96-8721-56295bdab607') {
        return inputTypes;
    }
    return inputTypes.map((type) => type === AIRCRAFT_COUNTABLE_TACH_TIME ? AIRCRAFT_COUNTABLE_FLIGHT_TIME : type);
};
const getNeedsResync = (remote, local) => {
    if (remote.changeTypes && local.changeTypes.length !== remote.changeTypes.length) {
        return true;
    }
    if (remote.countableTypes && local.countableTypes.length !== remote.countableTypes.length) {
        return true;
    }
    return false;
};
export const countableChangeFromDb = (input) => {
    const changeTypes = input.changeTypes
        ? input.changeTypes
        : [];
    const changeTypesDeduped = [...new Set(changeTypes)];
    const countableTypes = input.countableTypes ? input.countableTypes : [];
    const countableTypesDeduped = [...new Set(countableTypes)];
    const changeValues = input.changeValues ? input.changeValues : [];
    const { countableValuesBefore } = input;
    const { countableValuesAfter } = input;
    return {
        id: input.id,
        deleted: input.deleted,
        _version: input._version,
        editableByUserIds: input.editableByUserIds || [],
        aircraftId: input.aircraftId,
        flightId: input.flightId || undefined,
        legId: input.legId || undefined,
        createdAt: new Date(input.createdAt),
        createdByName: input.createdByName,
        place: input.place || undefined,
        type: input.type,
        changeTypes: migrateTypes(changeTypesDeduped, input.aircraftId),
        changeValues: deduplicate(changeTypesDeduped, changeTypes, changeValues),
        countableTypes: migrateTypes(countableTypesDeduped, input.aircraftId),
        countableValuesBefore: deduplicate(countableTypesDeduped, countableTypes, countableValuesBefore),
        countableValuesAfter: deduplicate(countableTypesDeduped, countableTypes, countableValuesAfter),
    };
};
const deduplicate = (uniqueTypes, types, values) => {
    return uniqueTypes.map((uniqueType) => {
        const index = types.lastIndexOf(uniqueType);
        return values[index];
    });
};
//# sourceMappingURL=countableChangeTransformers.js.map